import { Avatar as AvatarA, type AvatarProps } from 'antd';
import cn from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import styles from './avatar.module.css';

export type AvatarProperties = { color?: 'default' | 'primary'; fallbackPhoto: false | string } & AvatarProps;

// TODO: unify this component with Avatar in the client
const Avatar = ({ className, color = 'default', fallbackPhoto, src, ...rest }: AvatarProperties) => {
  const imageFallback = fallbackPhoto === false ? undefined : fallbackPhoto;
  const resolvedSource = src ?? imageFallback;
  const [avatarSource, setAvatarSource] = useState(resolvedSource);

  const handleError = useCallback(() => {
    if (imageFallback && avatarSource !== imageFallback) {
      setAvatarSource(imageFallback);
      return false;
    }
    setAvatarSource(undefined);
    return true;
  }, [imageFallback, avatarSource]);

  useEffect(() => {
    setAvatarSource(resolvedSource);
  }, [resolvedSource]);

  return (
    <AvatarA
      {...rest}
      className={cn(
        styles.avatar,
        {
          [styles.default ?? '']: color === 'default',
          [styles.primary ?? '']: color === 'primary',
        },
        className,
      )}
      onError={handleError}
      src={avatarSource}
    />
  );
};

Avatar.Group = AvatarA.Group;

export default Avatar;
